import { useLoaderData } from "react-router";
import { api } from "@/lib/api";
import HomepageLayout from "@/layouts/HomepageLayout";
import JuzsView from "@/components/JuzsView";

import type { Juz } from "@/lib/types";

export const juzsLoader = () => api<Juz[]>("/api/juzs?v=2");

export default function Juzs() {
	const juzs = useLoaderData<Juz[]>();

	return (
		<HomepageLayout>
			<JuzsView juzs={juzs} />
		</HomepageLayout>
	);
}
